(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConversationController', ConversationController);

    ConversationController.$inject = ['$state', '$stateParams', '$scope', '$rootScope', '$http', '$anchorScroll', 'emojiReplacer'];

    function ConversationController($state, $stateParams, $scope, $rootScope, $http, $anchorScroll, emojiReplacer) {
        var vm = this;
        vm.$onInit = init;
        vm.calculateTextareaHeight = calculateTextareaHeight;
        vm.close = close;
        vm.send = send;
        var updatetimer;
        vm.showUserProfile = [];

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Din profil - Beskeder - Be My Concert" : "Your profile - Messages - Be My Concert";
            $rootScope.no_scroll = true;
            $rootScope.hide_header = true;
            $rootScope.hide_footer = true;
            if($stateParams.conversation) {
                vm.conversation_id = $stateParams.conversation;
                getConversation();
                update();
            } else {
                vm.newConversation = true;
                getRecipient();
                vm.other_slug = $stateParams.recipient;
            }
        }

        function getRecipient() {
            $http.get('api/get_recipient/' + $stateParams.recipient + '/' + $stateParams.affiliate + '/').then(function (response) {
                vm.recipientName = response.data.recipient;
                vm.affiliate = response.data.affiliate;
                vm.other_name = vm.recipientName + ((vm.affiliate != '') ? ' @ ' + vm.affiliate : '');
            });
        }

        function close() {
            if($stateParams.return_page && $stateParams.return_slug){
                if($stateParams.return_page === 'musician'){
                    return $state.go('musician', {band_slug: $stateParams.return_slug});
                }
                if($stateParams.return_page === 'host'){
                    return $state.go('host', {space_slug: $stateParams.return_slug});
                }
            }

            if (history.length > 0) {
                if(vm.newConversation) {
                    $state.go('conversation', {conversation: vm.conversation_id}, {location: 'replace'}).then(function() {
                        window.history.go(-1);
                    });
                } else {
                    window.history.go(-1);
                }
            } else {
                $state.go('messages');
            }
        }

        function send() {
            if (vm.message_content !== '' && !vm.sending_message) {
                if(!vm.newConversation) {
                    vm.sending_message = true;
                    $http.post('api/send_message/', {
                        'message_content': emojiReplacer.replaceEmojis(vm.message_content),
                        'conversation_id': parseInt(vm.conversation_id),
                    }).then(function (response) {
                        vm.message_content = '';
                        vm.sending_message = false;
                        document.getElementById('message-textarea').style.height = "34px";
                        clearTimeout(updatetimer);
                        getNewMessages().then(update);
                    });
                } else {
                    vm.sending_message = true;
                    $http.post('api/new_conversation/', {
                        'recipient': $stateParams.recipient,
                        'affiliate': $stateParams.affiliate,
                    }).then(function (response) {
                        vm.conversation_id = response.data;
                        $http.post('api/send_message/', {
                            'message_content': emojiReplacer.replaceEmojis(vm.message_content),
                            'conversation_id': vm.conversation_id,
                        }).then(function (response) {
                            return $state.go('conversation',{conversation: vm.conversation_id, affiliate: $stateParams.affiliate, recipient: $stateParams.recipient}, {location: 'replace'}).then(function() {
                                vm.message_content = '';
                                vm.sending_message = false;
                                vm.newConversation = false;
                                document.getElementById('message-textarea').style.height = "34px";
                                getConversation();
                                update();
                            });
                        });
                    });
                }
            }
        }

        function getConversation() {
            return $http.get('api/conversation/' + vm.conversation_id + '/')
                .then(function (response) {
                    vm.message_groups = response.data.conversation;
                    vm.self_slug = response.data.self_slug;
                    vm.other_slug = response.data.other_slug;
                    vm.other_name = response.data.other_name;
                    vm.last_message_id = response.data.last_message_id;
                    formatMessages(vm.message_groups);
                    setTimeout(function () {
                        $anchorScroll(vm.last_message_id);
                    }, 0);
                    if($stateParams.affiliate) {
                        getRecipient();
                    }
                    $rootScope.$broadcast('update_notifications');
                });
        }

        function formatMessages(message_groups) {
            for (let [key, message_group] of Object.entries(message_groups)) {
                message_group.forEach(message => {
                    if(message.message_type === null) {
                        message.message_content = linkify(message.message_content);
                    }
                });
            }
        }

        function linkify(inputText) {
            inputText = inputText.replace(/( |^)(https:\/\/|http:\/\/)*([^ @\n]+(\b|$))(\.dk|\.com|\.co\.uk|\.org)($|[\S]+| )/gim, '$1<a href="http://$3$5$6" target="_blank">$3$5$6</a>');
            inputText = inputText.replace(/(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim, '<a href="mailto:$1">$1</a>');
            return inputText;
        }

        function getNewMessages() {
            return $http.get('api/conversation/' + vm.conversation_id + '/new/' + vm.last_message_id + '/')
                .then(function (response) {
                    if (response.data != "false") {
                        formatMessages(response.data.conversation);
                        if (vm.message_groups[Object.keys(response.data.conversation)[0]]) {
                            vm.message_groups[Object.keys(response.data.conversation)[0]] = vm.message_groups[Object.keys(response.data.conversation)[0]].concat(response.data.conversation[Object.keys(response.data.conversation)[0]]);
                        } else {
                            Object.assign(vm.message_groups, response.data.conversation)
                        }

                        vm.last_message_id = response.data.last_message_id;
                        setTimeout(function () {
                            $anchorScroll(vm.last_message_id);
                        }, 0);
                    }
                });
        }

        function calculateTextareaHeight(e) {
            setTimeout(function () {
                var scrollDown = document.querySelector('.conversation-page .container').scrollTop === document.querySelector('.conversation-page .container').scrollHeight - document.querySelector('.conversation-page .container').getBoundingClientRect().height;
                e.target.style.height = "0px"; //Reset to make sure height is decreased when linebreaks are removed
                e.target.style.height = (e.target.scrollHeight + 2 > 160 ? 160 : e.target.scrollHeight + 2) + "px";
                if (scrollDown)
                    document.querySelector('.conversation-page .container').scrollTop = document.querySelector('.conversation-page .container').scrollHeight - document.querySelector('.conversation-page .container').getBoundingClientRect().height;
            }, 0);
        }

        function update() {
            updatetimer = setTimeout(function () {
                getNewMessages();
                updatetimer = setTimeout(update, 10000);
            }, 10000);
        }

        $scope.$on('$destroy', function () {
            $rootScope.no_scroll = false;
            $rootScope.hide_header = false;
            $rootScope.hide_footer = false;
            clearTimeout(updatetimer);
        });
    }
})();
